import { ConsentHistory } from "@/components/shared/ConsentHistory";
import { PageHeader } from "@/components/shared";

export default function ConsentHistoryPage() {
  return (
    <div className="max-w-2xl mx-auto px-4 py-8">
      <PageHeader
        title="Consent & Privacy"
        subtitle="Full audit trail of contact sharing and access"
      />
      <ConsentHistory />
    </div>
  );
}
